import React from 'react';
import clsx from 'clsx';
import {Skeleton, Typography} from '@mui/material';
import TablePaginationActions, {
	type TablePaginationActionsProps,
} from '@mui/material/TablePagination/TablePaginationActions';
import {
	composeClasses,
	styled,
	type WithClasses,
} from '@netx/core-components/Theme';
import {
	getTablePagerVirtualizedUtilityClass,
	tablePagerVirtualizedClasses,
	type TablePagerVirtualizedClasses,
} from './tablePagerVirtualizedClasses';

type TablePagerVirtualizedOwnerState =
	WithClasses<TablePagerVirtualizedClasses>;

const useUtilityClasses = (ownerState: TablePagerVirtualizedOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getTablePagerVirtualizedUtilityClass, classes);
};

export interface TablePagerVirtualizedProps extends WithClasses<
	TablePagerVirtualizedClasses,
	TablePaginationActionsProps
> {
	loading?: boolean;
	rangeStart: number;
	rangeEnd: number;
	// currentPage: number;
}

const TablePagerVirtualizedRoot = styled('div', {
	name: 'TablePagerVirtualized',
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	alignItems: 'center',
	'& .MuiButtonBase-root': {
		color: theme.palette.text.primary,
	},
}));

const TablePagerVirtualizedLabel = styled('div', {
	name: 'TablePagerVirtualized',
	slot: 'Label',
})(({theme}) => ({
	paddingRight: theme.spacing(1),
}));

export const TablePagerVirtualizedPrimitive = ({
	classes: _classes,
	className,
	...props
}: TablePagerVirtualizedProps) => {
	const {count, rangeStart, rangeEnd, loading, page, ...sendProps} = props;
	const currentPage =
		rangeEnd === props.count - 1 ? Math.floor(count / props.rowsPerPage) : page;

	const ownerState = {
		classes: _classes,
	};
	const classes = useUtilityClasses(ownerState);

	return (
		<TablePagerVirtualizedRoot className={clsx(className, classes.root)}>
			<TablePagerVirtualizedLabel>
				{loading ? (
					<Skeleton width={75} />
				) : (
					<Typography variant="body2">
						{(rangeStart + 1).toLocaleString() + ' '}-{' '}
						{(rangeEnd + 1).toLocaleString() + ' '}of{' '}
						{props.count.toLocaleString()}
					</Typography>
				)}
			</TablePagerVirtualizedLabel>
			<TablePaginationActions
				{...sendProps}
				count={loading ? 0 : count}
				page={loading ? 0 : currentPage}
			/>
		</TablePagerVirtualizedRoot>
	);
};

export const TablePagerVirtualized = TablePagerVirtualizedPrimitive;

export default TablePagerVirtualized;
